import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { GenerateFinanceiroContratosListaColumns } from "./columns"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { ModelContratoFinanceiroLista } from "../../../domain/models/contrato_financeiro_lista"
import { useContratoFinanceiroListaViewModel } from "../../viewModels/contrato_financeiro_lista_view_model"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import { LegendComponent } from "../../../../../common/components/legend_component"
import { LegendItemComponent } from "../../../../../common/components/legend_item_component"
import { LegendIcon } from "../../../../../common/components/legend_icon"


export const FinanceiroContratosLista = () => {
    const viewModel = useContratoFinanceiroListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateFinanceiroContratosListaColumns({
            onActionEdit: viewModel.handleFinanceiroContratosEdit,
            onActionDelete: viewModel.handleFinanceiroContratosDeleteOpenState,

        });
    }, [
        viewModel.handleFinanceiroContratosEdit,
        viewModel.handleFinanceiroContratosDeleteOpenState,
    ]);

    return (
        <>
            {/*
             <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={

                    }
                />
            </PageTopBar> 
            */}

            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="primary-green"
                                    onClick={() => viewModel.handleParalisarContratos(false)}>
                                    Reativar Selecionados
                                </PrimaryButton>
                            </div>

                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleParalisarContratos(true)}>
                                    Paralisar Selecionados
                                </PrimaryButton>
                            </div>

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewFinanceiroContratos()}>
                                    Novo Cadastro
                                </PrimaryButton>
                            </div>

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleContratoFinanceiroRelatorio()}>
                                    Relatório Contratos
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit">
                        Financeiro
                    </Link>
                    <Typography className="text-primary-green">
                        Cadastro Contratos
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Contratos Financeiros Lista</h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                onClearFilters={viewModel.handleClearFilters}
                                ddlCentroCusto={viewModel.ddlCentroCusto}
                                ddlCliente={viewModel.ddlCliente}
                                descricao={viewModel.filters.descricao}
                                selectedIdsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
                                selectedIdsCliente={viewModel.filters.idsCliente ?? []}
                                selectedStatus={viewModel.filters.status ?? []}
                                dataInicioDe={viewModel.filters.dataInicioDe}
                                dataInicioAte={viewModel.filters.dataInicioAte}
                                dataDe={viewModel.filters.dataReceberDe}
                                dataAte={viewModel.filters.dataReceberAte}
                                codigo={viewModel.filters.codigo}
                                handleStatusChange={viewModel.handleStatusChange}
                                handleDataInicioRangeChange={viewModel.handleDataInicioRangeChange}
                                handleIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
                                handleIdClienteChange={viewModel.handleIdClienteChange}
                                handleDataRangeChange={viewModel.handleDataReceberRangeChange}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                handleCodigoChange={viewModel.handleCodigoChange}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col flex-wrap justify-end">
                                        <LegendComponent>
                                            <LegendItemComponent
                                                icon={<LegendIcon color='gray' title='EA' />}
                                                label='Em Andamento' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='green' title='F' />}
                                                label='Finalizada' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='yellow' title='P' />}
                                                label='Paralisada' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='red' title='C' />}
                                                label='Cancelada' />

                                        </LegendComponent>
                                    </div>

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="contas_receber_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ModelContratoFinanceiroLista) => row.idContratoFinanceiro}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={true}
                                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                                    rowSelectionModel={viewModel.rowSelectionModel}
                                    rows={viewModel.financeiroContratosLista}
                                    rowCount={viewModel.financeiroContratosLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    textSize="muitoPequeno"
                                    getRowHeight={() => 'auto'}
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        left: ["__check__"],
                                        right: ['idContratoFinanceiro'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <DeleteDialog
                                open={viewModel.openDeleteModal}
                                onClose={() => viewModel.handleFinanceiroContratosDeleteOpenState(null, false)}
                                title={`Você realmente deseja excluir este item?`}
                                onDelete={viewModel.handleConfirmarDeletarFinanceiroContratos}
                            />

                            <ReportViewerModal
                                reportViewerState={viewModel.reportViewerState}
                            />


                        </>
                    )
                }

            </div >
        </>
    )
}
